window.percentageFormatter = function(value, row) {
    if (value !== 0 && value !== '0' && value !== '0,00') {
        return value+'%';
    }
};
